// components/designer/ComponentLibraryPanel.tsx
/**
 * Component Library Panel
 *
 * Left sidebar showing available components that can be added to the canvas.
 */
// components/designer/ComponentLibraryPanel.tsx

import { Button } from "@shared/ui/button";
import { FileText } from "lucide-react";
import React from "react";

interface ComponentLibraryPanelProps {
  availableComponents: any[];
  onAddComponent: (component: any) => void;
}

const ComponentLibraryPanel: React.FC<ComponentLibraryPanelProps> = ({
  availableComponents,
  onAddComponent,
}) => {
  return (
    <div className="flex-1 flex flex-col">
      <div className="p-4 border-b">
        <h3 className="font-semibold text-sm">Component Library</h3>
      </div>

      {/* Simple native scroller */}
      <div className="h-[400px] overflow-y-auto p-2 space-y-2">
        {availableComponents.length > 0 ? (
          availableComponents.map((comp: any) => (
            <Button
              key={comp.id}
              variant="outline"
              className="w-full justify-start text-xs"
              onClick={() => onAddComponent(comp)}
            >
              <FileText size={14} className="mr-2" />
              {comp.componentName}
            </Button>
          ))
        ) : (
          <div className="text-center text-gray-500 py-8">
            <p className="text-xs">Loading...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ComponentLibraryPanel;
